import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=4c4aeba8&scoped=true&"
import script from "./BubbleChart.vue?vue&type=script&lang=js&"
export * from "./BubbleChart.vue?vue&type=script&lang=js&"
import style0 from "./BubbleChart.vue?vue&type=style&index=0&id=4c4aeba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4aeba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
